<template>
	<div class="flex flex-col md:flex-row my-4">
		<div class="px-4 md:w-1/3">
			<img class="mx-auto" :src="resolve_img_url(imageName)" />
		</div>
		<div class="md:pt-0 md:w-2/3 pr-4 pt-2">
			<p class="font-bold md:px-0 px-2 text-red-800 text-xl">{{ title }}</p>
			<div
				v-for="(paragraph, index) in text"
				:key="index"
			>
				<p class="md:px-0 px-2">{{ paragraph }}</p>
				<br/>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ServiceTile',
	methods: {
		resolve_img_url: function (path) {
			let images = require.context('../assets/', false, /\.png$|\.jpg$/)
			return images("./"+path)
		}
	},
	props: {
		imageName: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		text: {
			type: Array,
			required: true,
		},
	},
}

</script>